export interface BloodProductsTypes {
  administration1: string,
  administration2: string,
  administration3: string,
  administration4: string,
  administration5: string,
  aliquoted: string,
  applicationRoute: string,
  applicationRouteMaterial1: string,
  applicationRouteMaterial2: string,
  applicationRouteMaterial3: string,
  applicationRouteMaterial4: string,
  applicationRouteMaterial5: string,
  bloodProduct: string,
  bloodProductDescription: string,
  bloodProductDescriptionId: number,
  bloodProductType: string,
  bloodProductUnitMeasurement: string,
  dateScheduled: moment.Moment,
  diagnosis: string,
  diluentMeasurementUnit1: string,
  diluentMeasurementUnit2: string,
  diluentMeasurementUnit3: string,
  diluentMeasurementUnit4: string,
  diluentMeasurementUnit5: string,
  dose1: number,
  dose2: number,
  dose3: number,
  dose4: number,
  dose5: number,
  doseDiluent1: number,
  doseDiluent2: number,
  doseDiluent3: number,
  doseDiluent4: number,
  doseDiluent5: number,
  doseMeasurementUnit1: string,
  doseMeasurementUnit2: string,
  doseMeasurementUnit3: string,
  doseMeasurementUnit4: string,
  doseMeasurementUnit5: string,
  endDate: moment.Moment,
  filtered: string,
  hours: string,
  hoursMaterial1: string,
  hoursMaterial2: string,
  hoursMaterial3: string,
  hoursMaterial4: string,
  hoursMaterial5: string,
  id: number,
  infusionSpeed: number,
  interval1: string,
  interval2: string,
  interval3: string,
  interval4: string,
  interval5: string,
  intervalDescription: string,
  irradiated: string,
  material1: string,
  material2: string,
  material3: string,
  material4: string,
  material5: string,
  materialDiluent1: string,
  materialDiluent2: string,
  materialDiluent3: string,
  materialDiluent4: string,
  materialDiluent5: string,
  materialDiluentId1: number,
  materialDiluentId2: number,
  materialDiluentId3: number,
  materialDiluentId4: number,
  materialDiluentId5: number,
  materialId1: number,
  materialId2: number,
  materialId3: number,
  materialId4: number,
  materialId5: number,
  materialObservation1: string,
  materialObservation2: string,
  materialObservation3: string,
  materialObservation4: string,
  materialObservation5: string,
  observation: string,
  patientType: string,
  phenotyped: string,
  prescriberDt: string,
  prescriberName: string,
  procedure: string,
  procedureType: number,
  quantityProcedure: number,
  recommendationDescription: string,
  recommendationId: number,
  reserve: string,
  startDate1: moment.Moment,
  startDate2: moment.Moment,
  startDate3: moment.Moment,
  startDate4: moment.Moment,
  startDate5: moment.Moment,
  totalInfusionDuration: string,
  transfusionModality: string,
  transfusionModalityType: number,
  unitInfusionDuration: string,
  volume: number,
  volumeToBeRemoved: number,
  washed: string
}

export enum BloodProductsType {
  PROCEDURE = '1',
  BLOOD_PRODUCTS = '0'
}

export const bloodProductsDescriptionWithInterval = {
  FRESH_FROZEN_PLASMA: 6,
  PACKED_RED_BLOOD_CELLS: 14,
  RED_BLOOD_CELL_CONCENTRATE: 1,
  THERAPEUTIC_APHERESIS: 11
}

export enum ProcedureType {
  THERAPEUTIC_APHERESIS = 1717
}

export enum TransfusionModalityType {
  EMERGENCY = 4
}